import PropTypes from 'prop-types';
const CubbyIcon = ({ height, width }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <mask
        id="mask0_2022_3136"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2022_3136)">
        <path
          d="M13.0294 9.52941V5H19V9.52941H13.0294ZM5 12.4118V5H10.9706V12.4118H5ZM13.0294 19V11.5882H19V19H13.0294ZM5 19V14.4706H10.9706V19H5ZM6.23529 11.1765H9.73529V6.23529H6.23529V11.1765ZM14.2647 17.7647H17.7647V12.8235H14.2647V17.7647ZM14.2647 8.29412H17.7647V6.23529H14.2647V8.29412ZM6.23529 17.7647H9.73529V15.7059H6.23529V17.7647Z"
          fill="var(--react-select-text)"
        />
      </g>
    </svg>
  );
};
CubbyIcon.propTypes = {
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
export default CubbyIcon;
